const domain = {
  // development: "http://172.23.50.22:7001",
  development: 'http://127.0.0.1:7001',
  test: "http://172.26.1.116:7001",
  production: "https://172.23.50.22:7001",
};

const ddConfig = {
  development: {
    redirectUrl: 'http://localhost:8080/main',
    appId: 'dingoaqqhd1s4khs9vybpt'
  },
  test: {
    redirectUrl: 'http://172.23.50.22:8003/main',
    appId: 'dingoatptdviiigq0bmwq2'
  },
  production: {
    redirectUrl: 'http://172.23.50.22:8003/main',
    appId: 'dingoatptdviiigq0bmwq2'
  }
}

const env = process.env.VUE_APP_ENV

const data = {
  domain: domain[env],
  ddConfig: ddConfig[env]
}

export const indexContent = '<h2 style="margin: 30px 0 0; color: rgb(23, 43, 77); font-size: 20px; font-weight: normal; line-height: 1.5; letter-spacing: -0.008em;"><strong>简介</strong></h2><p style="margin-top: 10px; margin-bottom: 0px;">本文档描述了租户申请开放平台API的接入流程。</p><h3 style="margin: 30px 0px 0px; color: rgb(23, 43, 77); font-size: 16px; line-height: 1.5; letter-spacing: -0.006em;"><strong>接入流程</strong></h3><p style="margin-top: 10px; margin-bottom: 0px;"><img class="confluence-embedded-image" title="SME-架构 &gt; 1. 接入指引 &gt; 开放平台.png" width="900" src="https://prd-cabinet-1257122416.cos.ap-shanghai.myqcloud.com/oapijoin.png"/></p><h3 style="margin: 30px 0px 0px; color: rgb(23, 43, 77); font-size: 16px; line-height: 1.5; letter-spacing: -0.006em;">准备工作</h3><ol style="margin-top: 10px;" class=" list-paddingleft-2"><li><p>完成租户注册。</p></li><li><p>通过云帐房开放平台邮件审核。</p></li><li><p>分配accessKey，每个租户分配一个accessKey。</p></li><li><p>accessKey分配有各类API的调用权限，当前阶段不限制<br/><br/></p></li></ol><p class="with-breadcrumbs" style="margin-top: 10px; margin-bottom: 0px;"><br/></p><p style="margin-top: 10px; margin-bottom: 0px;"><br/></p><p><br/></p>'

export default data
